<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    style="top: 2.8125rem"
    :style="isSidebarCollapsed ? 'width: 50px' : 'width: 260px'"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->

    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area border-right-light"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <div
      v-if="$store.state.app.windowWidth > 1199"
      class="p-75 d-flex justify-content-end border-top w-100 cursor-pointer"
      @click="isSidebarCollapsed = !isSidebarCollapsed"
    >
      <GjIcon
        v-if="!isSidebarCollapsed"
        name="SidebarLeft"
        size="24"
      />
      <GjIcon
        v-else
        name="SidebarRight"
        size="24"
      />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
// import ProjectsDropdown from '@/components/projects-dropdown/ProjectsDropdown.vue'
import navMenuItems from '@/navigation/vertical'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    // BLink,
    // BImg,
    // ProjectsDropdown,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  computed: {
    activeProjectId() {
      return this.$store.getters['projectModule/getActiveProjectId']
    },
    isSidebarCollapsed: {
      get() {
        return this.$store.state.projectModule.isSidebarCollapsed && this.$store.state.app.windowWidth > 1199
      },
      set() {
        this.$store.state.projectModule.isSidebarCollapsed = !this.$store.state.projectModule.isSidebarCollapsed
      },
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, vpLogo } = $themeConfig.app

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      vpLogo,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
